import { createContext } from 'use-context-selector';
const SidebarGroupContext = createContext({
    onItemActive: () => null
});
export default SidebarGroupContext;
